/**
 * 应用入口文件
 * 
 * 初始化：
 * - 全局主题令牌与主题色
 * - Vue 应用实例
 * - Pinia 状态管理
 * - Vue Router 路由
 * - 模块注册
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router, { injectModuleRoutes } from './router'
import { moduleRegistry } from './modules'
import { applyTheme, readStoredThemeColor, readStoredThemeMode } from './utils/theme'
import { useThemeStore } from './stores'

// 全局样式：主题令牌需先于组件样式加载
import './styles/theme.css'

// 挂载前应用主题（主题色 + 明暗模式），避免首屏闪回默认外观
applyTheme(readStoredThemeColor(), readStoredThemeMode())

// 导入所有功能模块（触发注册）
import { authModule } from './modules/auth'
import { dashboardModule } from './modules/dashboard'
import { profileModule } from './modules/profile'
import { galleryModule } from './modules/gallery'
import { webdavModule } from './modules/webdav'
import { tasksModule } from './modules/tasks'
import { subsystemsModule } from './modules/subsystems'
import { lifeModule } from './modules/life'
import { settingsModule } from './modules/settings'
import { graduateModule } from './modules/graduate'
import { notesModule } from './modules/notes'

// 创建应用实例
const app = createApp(App)

// 安装 Pinia
const pinia = createPinia()
app.use(pinia)

// 初始化主题（同步系统深色偏好，auto 模式下实时跟随）
useThemeStore().init()

// 注册所有模块
moduleRegistry.registerAll([
  authModule,
  dashboardModule,
  profileModule,
  galleryModule,
  webdavModule,
  tasksModule,
  subsystemsModule,
  lifeModule,
  settingsModule,
  graduateModule,
  notesModule
])

// 注入模块路由
injectModuleRoutes()

// 安装路由
app.use(router)

// 挂载应用
app.mount('#app')

console.info('[App] 个人工作台前端已启动')
